import RadioGroup from "@p-ban/common/src/components/form/radio/RadioGroup"

import ESTIMATE_CONSTANT from "../../../../../constant/estimateConstant"
import FIELD_NAMES from "../../../../../constant/fieldNames"
import getDisplayCondition from "../../../../../service/getDisplayCondition"
import type { OneClickFieldProps } from "../../../../../types"
import OneClickField from "../../../../components/1Click/form/OneClickField"
import OneClickFieldMessages from "../../../../components/1Click/form/OneClickFieldMessages"
import OneClickFieldStack from "../../../../components/1Click/form/OneClickFieldStack"
import Radio from "../../../../components/1Click/form/Radio/Radio"
import HELP_LINKS from "../../../../constant/helpLinks"
import isValidBeatenThickness from "../../../../service/visibleValidator/isValidBeatenThickness"

import img from "./copperThickness.png"

const 銅箔厚み = ({ values, handlers, errors }: OneClickFieldProps) => {
  const { beatenThickness: shouldShow } = getDisplayCondition(values)

  return (
    <OneClickField isShow={shouldShow} legend="銅箔厚み" helpURL={HELP_LINKS.銅箔厚み} src={img}>
      <RadioGroup
        name={FIELD_NAMES.銅箔厚み}
        selectedValue={values.beatenThickness}
        onChange={handlers.radio}
        shouldRender={(value) => isValidBeatenThickness(values, value)}
      >
        <OneClickFieldStack>
          <Radio value={ESTIMATE_CONSTANT.銅箔厚み["18μm(リジッド)"].value}>18μm</Radio>
          <Radio value={ESTIMATE_CONSTANT.銅箔厚み["35μm(リジッド)"].value}>35μm</Radio>
          <Radio value={ESTIMATE_CONSTANT.銅箔厚み["70μm(リジッド)"].value}>70μm</Radio>
          <Radio value={ESTIMATE_CONSTANT.銅箔厚み["105μm"].value}>105μm</Radio>
          <Radio value={ESTIMATE_CONSTANT.銅箔厚み["140μm"].value}>140μm</Radio>
          <Radio value={ESTIMATE_CONSTANT.銅箔厚み["175μm"].value}>175μm</Radio>

          <Radio value={ESTIMATE_CONSTANT.銅箔厚み["内層35μm外層18μm"].value}>内層35μm外層18μm</Radio>
          <Radio value={ESTIMATE_CONSTANT.銅箔厚み["内層18μm外層18μm(リジッド)"].value}>内層18μm外層18μm</Radio>

          <Radio value={ESTIMATE_CONSTANT.銅箔厚み.内層18μm外層35μm.value}>内層18μm外層35μm</Radio>
          <Radio value={ESTIMATE_CONSTANT.銅箔厚み.内層35μm外層35μm.value}>内層35μm外層35μm</Radio>
          <Radio value={ESTIMATE_CONSTANT.銅箔厚み.内層18μm外層70μm.value}>内層18μm外層70μm</Radio>
          <Radio value={ESTIMATE_CONSTANT.銅箔厚み.内層35μm外層70μm.value}>内層35μm外層70μm</Radio>
          <Radio value={ESTIMATE_CONSTANT.銅箔厚み.内層70μm外層18μm.value}>内層70μm外層18μm</Radio>
          <Radio value={ESTIMATE_CONSTANT.銅箔厚み.内層70μm外層35μm.value}>内層70μm外層35μm</Radio>
          <Radio value={ESTIMATE_CONSTANT.銅箔厚み.内層70μm外層70μm.value}>内層70μm外層70μm</Radio>

          <Radio value={ESTIMATE_CONSTANT.銅箔厚み["9μm"].value}>9μm</Radio>
          <Radio value={ESTIMATE_CONSTANT.銅箔厚み["12μm"].value}>12μm</Radio>
          <Radio value={ESTIMATE_CONSTANT.銅箔厚み["18μm(フレキシブル__0.1mm未満)"].value}>18μm</Radio>
          <Radio value={ESTIMATE_CONSTANT.銅箔厚み["18μm(フレキシブル__0.1mm以上__片面)"].value}>18μm</Radio>
          <Radio value={ESTIMATE_CONSTANT.銅箔厚み["18μm(フレキシブル__0.1mm以上__2層)"].value}>18μm</Radio>
          <Radio value={ESTIMATE_CONSTANT.銅箔厚み["35μm(フレキシブル__片面)"].value}>35μm</Radio>
          <Radio value={ESTIMATE_CONSTANT.銅箔厚み["35μm(フレキシブル__2層)"].value}>35μm</Radio>
          <Radio value={ESTIMATE_CONSTANT.銅箔厚み["内層12.5μm外層12.5μm"].value}>内層12.5μm外層12.5μm</Radio>
          <Radio value={ESTIMATE_CONSTANT.銅箔厚み["内層18μm外層18μm(フレキシブル)"].value}>内層18μm外層18μm</Radio>

          <Radio value={ESTIMATE_CONSTANT.銅箔厚み["35μm(メタル)"].value}>35μm</Radio>
          <Radio value={ESTIMATE_CONSTANT.銅箔厚み["70μm(メタル)"].value}>70μm</Radio>
        </OneClickFieldStack>
      </RadioGroup>
      <OneClickFieldMessages error={errors?.beatenThickness} />
    </OneClickField>
  )
}

export default 銅箔厚み
